<script>
import {client, defaultPagination} from "../../../sci/helpers";

export default {
    name: "ConstructionCustomerInterestedTab",
    props: {
        construction: {required: true},
        shows: {required: true}
    },
    data() {
        return {
            page: 0,
            interestedForms: [],
            ui : {
                show: {
                    recommended: false,
                },
                loadInterestedForms: false,
                interestedFormsPagination: defaultPagination()
            }
        }
    },
    methods: {
        showRecommended() {
            this.ui.show.recommended = !this.ui.show.recommended

            if (this.ui.show.recommended || this.shows['recommended']) {
                this.loadInterestedForms(1)
            }
        },
        async loadInterestedForms(page) {
            this.ui.loadingInterestedForms = true

            client
                .silent()
                .get('Carregando...', `/constructions/${this.construction.id}/interested`, {
                    page
                })
                .then((data) => {
                    this.$emit('shows', 'recommended')
                    this.interestedForms = data.data
                    this.ui.interestedFormsPagination = data.meta.pagination

                    this.ui.loadingInterestedForms = false
                })
        },
    }
}
</script>

<template>
    <div>
        <div class="row">
            <div class="col-xs-12 text-center" style="margin:30px 0;">
                <button class="btn blue" @click="showRecommended">
                    <span v-if="!shows['recommended']">Ver informações</span>
                    <span v-if="shows['recommended']">Ocultar informações</span>
                </button>
            </div>
        </div>
        <ui-loading :state="ui.loadingInterestedForms" text="Carregando..." v-if="shows['recommended']">
            <table class="table table-striped hidden-owner-info">
                <tbody>
                <tr v-for="form in interestedForms">
                    <td>
                        <a target="_blank" v-bind:href="'/forms/' + form.id">{{ form.customer.name }}</a>
                    </td>
                    <td>{{form.status.name}}</td>
                    <td>Alterado há {{form.touched_at | timeago}}</td>
                </tr>
                </tbody>
            </table>
        </ui-loading>
        <ui-pagination :data="ui.interestedFormsPagination"
                       :page-changed="loadInterestedForms">

        </ui-pagination>
    </div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionCustomerInterestedTab.vue?f3056846